import { Fragment, useState } from 'react'

import { useModals, useRegisterReload } from '../../../../hooks'
import { useRequestProfileContext } from '../../RequestProfile.hooks'
import { ACTIVITIES_MODALS_CONFIG } from '../RequestProfileTabActivities.constants'
import { RequestProfileTabActivitiesContext } from '../RequestProfileTabActivities.context'
import {
  useRequestProfileTabActivitiesLoader,
  useRequestProfileTabActivitiesReload,
} from '../RequestProfileTabActivities.hooks'

function RequestProfileTabActivitiesContextProvider({
  children,
  outboundUuid,
  requestId,
  onPhasesMetadataChange,
}) {
  const { registerActivitiesTabReload } = useRequestProfileContext()

  const [isReorderingActivities, setReorderingActivities] = useState(false)

  const loaderValue = useRequestProfileTabActivitiesLoader({
    outboundUuid,
    requestId,
    onPhasesMetadataChange,
  })

  const { handleReload } = loaderValue

  useRegisterReload({
    reload: handleReload,
    onRegisterReload: registerActivitiesTabReload,
  })

  const { handleReloadAll, handleReloadAllDelayed } =
    useRequestProfileTabActivitiesReload({ requestId, onReload: handleReload })

  const {
    closeEmailFormModal,
    closeModal,
    modals,
    setEmailFormModal,
    setModal,
  } = useModals(ACTIVITIES_MODALS_CONFIG)

  const value = {
    ...loaderValue,
    closeEmailFormModal,
    closeModal,
    handleReloadAll,
    handleReloadAllDelayed,
    isReorderingActivities,
    requestId,
    setEmailFormModal,
    setModal,
    setReorderingActivities,
  }

  return (
    <RequestProfileTabActivitiesContext value={value}>
      {children}
      {modals.map(([id, element]) => (
        <Fragment key={id}>{element}</Fragment>
      ))}
    </RequestProfileTabActivitiesContext>
  )
}

export default RequestProfileTabActivitiesContextProvider
